import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  constructor(private httpClient: HttpClient) { }

  public getGmonTimeView(gridNodeId: number): Observable<any> {
    const gridNodeIds = new Array<number>();
    gridNodeIds.push(gridNodeId);

    const body = JSON.stringify(gridNodeIds);

    return this.httpClient.post(environment.API_BASE_URL + "application/gmon/getData", body);
  }

  public getFeederNodes(cableGridElementId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/getFeederNodes/" + cableGridElementId);
  }
  public getFeederCables(cableGridElementId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/getFeederCables/" + cableGridElementId);
  }

  public getAllGMonData(topologyId: string): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/gmon/getAllData/" + topologyId);
  }

  public getGmonData(gridNodeIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridNodeIds);

    return this.httpClient.post(environment.API_BASE_URL + "application/gmon/getData", body);
  }

  public getGmonDataPlanning(scenarioId: number, gridNodeId: number): Observable<any> {
    const gridNodeIds = new Array<number>();
    gridNodeIds.push(gridNodeId);

    const body = JSON.stringify(gridNodeIds);

    return this.httpClient.post(environment.API_BASE_URL + "application/gmon/getDataPlanning/" + scenarioId, body);
  }

  public getGmonDataFeederView(gridNodeIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridNodeIds);

    return this.httpClient.post(environment.API_BASE_URL + "application/gmon/getDataFeederView", body);
  }

  public getGmonDataFeederViewPlanning(scenarioId: number, gridNodeIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridNodeIds);

    return this.httpClient.post(environment.API_BASE_URL + "application/gmon/getDataFeederViewInPlanning/" + scenarioId, body);
  }

  public getGmonDataFeederViewForPlanning(gridNodeIds: Array<number>, scenarioId: number): Observable<any> {
    const body = JSON.stringify(gridNodeIds);

    return this.httpClient.post(environment.API_BASE_URL + "application/gmon/getDataFeederView/" + scenarioId, body);
  }

  public getAllLCData(topologyId: string): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/lc/getData/" + topologyId);
  }

  public getLANodeData(gridElementId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/la/getNodeData/" + gridElementId);
  }

  public getLANodeDataInPlanning(scenarioId: number, gridElementId: number): Observable<any> {
    const gridNodeIds = new Array<number>();
    gridNodeIds.push(gridElementId);
    const body = JSON.stringify(gridNodeIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getNodeDataInPlanning/" + scenarioId, body);
  }

  public getLANodesData(gridNodeIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridNodeIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getNodesData", body);
  }
  public getLANodesDataFeederView(gridNodeIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridNodeIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getNodesDataFeederView", body);
  }

  public getLANodesDataFeederViewPlanning(scenarioId: number, gridNodeIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridNodeIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getNodesDataFeederViewInPlanning/" + scenarioId, body);
  }

  public getLANodesDataFeederViewByScenarioId(gridNodeIds: Array<number>, scenarioId): Observable<any> {
    const body = JSON.stringify(gridNodeIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getNodesDataFeederView/" + scenarioId, body);
  }

  public getRPADataFeederView(gridNodeIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridNodeIds);

    return this.httpClient.post(environment.API_BASE_URL + "application/rpa/getDataFeederView", body);
  }

  //getNodesDataFeederView
  /**
   * @param {number} gridElementId The Cable gridElementId.
   */
  public getLACableData(gridElementId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/la/getCableData/" + gridElementId);
  }

  public getLACableDataInPlanning(scenarioId: number, gridElementId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/la/getCableDataInPlanning/" + gridElementId + "/" + scenarioId);
  }
  //getCablesDataFeederView

  public getLACablesDataFeederView(cableGridElementIds: Array<number>): Observable<any> {
    const body = JSON.stringify(cableGridElementIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getCablesDataFeederView", body);
  }

  public getLACablesDataFeederViewPlanning(scenarioId: number, cableGridElementIds: Array<number>): Observable<any> {
    const body = JSON.stringify(cableGridElementIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getCablesDataFeederViewInPlanning/" + scenarioId, body);
  }

  public getLACablesDataFeederViewByScenarioId(cableGridElementIds: Array<number>, scenarioId: number): Observable<any> {
    const body = JSON.stringify(cableGridElementIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getCablesDataFeederView/" + scenarioId, body);
  }

  public getLACablesData(cableGridElementIds: Array<number>): Observable<any> {
    const body = JSON.stringify(cableGridElementIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getCablesData", body);
  }

  public getReactivePowerAnalysisData(gridElementIds: Array<number>): Observable<any> {
    const body = JSON.stringify(gridElementIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/rpa/getData/", body);
    // return this.httpClient.get("assets/locale-files/reactivePowerAnalysis_testJson.json");
  }

  public getGplanGmonData(scenarioId: number, gridElementId: number): Observable<any> {
    const gridNodeIds = new Array<number>();
    gridNodeIds.push(gridElementId);
    const body = JSON.stringify(gridNodeIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/gmon/getGridPlanningData/" + scenarioId, body);
  }

  // For nodes:
  public getGplanLANodeData(scenarioId: number,gridElementId: number): Observable<any> {
    const gridNodeIds = new Array<number>();
    gridNodeIds.push(gridElementId);
    const body = JSON.stringify(gridNodeIds);
    return this.httpClient.post(environment.API_BASE_URL + "application/la/getNodePlanningData/" + scenarioId, body);
  }

  // For cables:
  public getGplanLACableData(scenarioId: number, gridElementId: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/la/getCablePlanningData/" + gridElementId + "/" + scenarioId);
  }

  public downloadReport(): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/report",{ observe: 'response',responseType: 'blob'});
  }

  //Live Monitoring and Control
  public runLiveMonitoringAndControl(body){
    console.log("BODY of runLiveMonitoringAndControl: ", body)
    return this.httpClient.post(environment.API_BASE_URL + "gui/runLM", body)
  }

  public stopLiveMonitoringAndControl(body){
    console.log("BODY of stopLiveMonitoringAndControl: ", body)
    return this.httpClient.post(environment.API_BASE_URL + "gui/stopLM", body)
  }

  public getLmParameters(topologyId:string):Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "gui/lmParameters/"+topologyId);
  }
  //LivePowerData tab.  Only for Nodes (Junction Box and Customer ConnectionBox, and Trafo)
  public getLivePowerNodes(gridNodeId: number, hours: number): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "application/lmLa/getNodeData/" + gridNodeId + "/" + hours)
  }

  //Power, LA Data for Cables. Live Cable Load tab.
  public getLiveCablePowerLoad(gridNodeId: number, hours: number): Observable<any>{
    return this.httpClient.get(environment.API_BASE_URL + "application/lmLa/getCableData/" + gridNodeId + "/" + hours);
  }

  //Only for Trafo Live Voltage Data tab
  public getLiveVoltageDataTrafo(gridNodeId: number, hours: number): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "application/lmGmon/getNodeData/" + gridNodeId + "/" + hours);
  }

  //Get the list of all controllable devices *With new icon, the data is similar to magnifier icon
  public getControllableDevices(topologyId: string): Observable<any> {
    return this.httpClient.get(environment.API_BASE_URL + "gui/getControllableDevices/" + topologyId);
  }


}
